import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

export const input = (theme: Theme) => css`
  padding: 0;
  width: 100%;
  color: ${theme.palette.neutral[900]};
  caret-color: ${theme.palette.brand[500]};
  border: none;
  background-color: transparent;
  /* 16px to prevent ios zooming */
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  text-align: end;

  &::placeholder,
  &.empty {
    color: ${theme.palette.neutral[700]};
    font-weight: 400;
  }

  &:disabled {
    opacity: 1; /* required on iOS */
    -webkit-text-fill-color: ${theme.palette
      .neutral[600]}; /* required on iOS */
    color: ${theme.palette.neutral[600]};
    cursor: not-allowed;
  }
`
